
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: 'VacancyEventCard',
  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    const idNavigationLeft = `vacancy-event-card__button-navigation--prev-${ (Math.random() + 1).toString(36).substring(7) }`;
    const idNavigationRight = `vacancy-event-card__button-navigation--next-${ (Math.random() + 1).toString(36).substring(7) }`;

    return {
      idNavigationLeft,
      idNavigationRight,

      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 1.2,
        slidesPerGroup: 1,

        breakpoints: {
          1200: {
            spaceBetween: 20,
            slidesPerView: 2.7,
            slidesPerGroup: 2,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: 2.2,
            slidesPerGroup: 2,
          },
          640: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
          },
        },
        // navigation: {
        //   prevEl: `#${ idNavigationLeft }`,
        //   nextEl: `#${ idNavigationRight }`,
        // },
      },

      activeSlide: 1,
      totalSlides: 0,

      windowWidth: null,
    }
  },

  props: {
    event: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  computed: {
    // фильтрация изображений по флагу "Важные" потом сверить флаг (на беке тоже есть, но с нашей стороны оставил)
    eventImagesForShowing: function () {
      let arr = [];
      let double = [];
      arr = Object.values(this.event.images);
      double = arr;
      // return arr.join(double)
      return arr.filter((item) => item.show_on_main === '1');
    },
    linkToEvent: function () {
      return `/events/${this.event.slug}` || '/';
    },
    isMobile: function () {
      return this.windowWidth <= 1024;
    },
    activeSlides: function () {
      // return console.log('this.$refs.refSwiper.$swiper', this.$refs.refSwiper.$swiper.activeIndex)
    }
  },

  methods: {
    initSwiper: function () {
      // this.$refs.refSwiper.$swiper?.passedParams.slidesPerGroup для пересчета
      // this.totalSlides =  (this.$refs.refSwiper?.$swiper?.snapGrid || []).length
      this.totalSlides = this.eventImagesForShowing.length
    },

    slideChange: function () {
      // this.$refs.refSwiper.$swiper?.passedParams.slidesPerView для пересчета
      // this.activeSlide = this.$refs?.refSwiper?.$swiper?.activeIndex + 1 //snapIndex + 1;
      if ( Number(this.$refs?.refSwiper?.$swiper?.snapIndex) === Number(this.$refs?.refSwiper?.$swiper?.snapGrid?.length - 1 )) {
        this.activeSlide = this.$refs?.refSwiper?.$swiper?.slidesGrid?.length
      } else this.activeSlide = this.$refs?.refSwiper?.$swiper?.activeIndex + 1
      //this.activeSlide = this.$refs?.refSwiper?.$swiper?.snapIndex
      // console.log('this.$refs.refSwiper.$swiper', this.$refs.refSwiper.$swiper)
    },
    handleWindowSize: function () {
      if (!process.client) {
        return;
      }
      this.windowWidth = window.innerWidth;
    },
    slidePrev: function () {
      this.$refs?.refSwiper?.$swiper.slidePrev();
      // console.log('swiper: <<<<------ ', this.$refs.refSwiper.$swiper);
    },
    slideNext: function () {
      this.$refs?.refSwiper?.$swiper.slideNext();
      // console.log('swiper: ------->>>>> ', this.$refs.refSwiper.$swiper);
    },
    reachEndSlider: function () {
      this.activeSlide = this.$refs?.refSwiper?.$swiper?.slidesGrid?.length
    }
  },
  mounted() {
    this.handleWindowSize();
    window.addEventListener('resize', this.handleWindowSize);
  },
  unMounted() {
    window.removeEventListener('resize', null);
  }
};
